import trimStart from './trimStart';
import trimEnd from './trimEnd';

function trim(value?: string, character?: string) {
  return trimEnd(trimStart(value, character), character);
}

export default trim;
